import { render } from "./FeedbackSuccess.vue?vue&type=template&id=a1bc5b38&scoped=true"
const script = {}

import "./FeedbackSuccess.vue?vue&type=style&index=0&id=a1bc5b38&scoped=true&lang=css"
import "./FeedbackSuccess.vue?vue&type=style&index=1&id=a1bc5b38&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1bc5b38"]])

export default __exports__